import React from 'react'
import { connect } from 'react-redux'
import { userActions, geoActions } from '../../redux/actions'
import { currentUser } from '../../redux/reducers/user.reducers'
import SubmitPhoneForm from '../Form/SubmitPhoneForm/SubmitPhoneForm'

class SubmitPhone extends React.Component {
  componentDidMount() {
    const { getCountry } = this.props

    getCountry()
  }

  _handleSubmit = values => {
    const { changePhoneNumber, countryCode, user } = this.props
    const mergedValues = {
      // eslint-disable-next-line camelcase
      user_id: user.id,
      phone: values.phone,
      countryCode,
    }
    // TODO: Make protected route
    return changePhoneNumber(mergedValues)
  }

  render() {
    const { countryCode } = this.props
    return (
      <div aria-labelledby="submit-phone-heading" tabIndex={-1}>
        <h1 id="submit-phone-heading" className="sr-only">
          Submit Your Phone Number
        </h1>
        <SubmitPhoneForm onSubmit={this._handleSubmit} countryCode={countryCode} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: currentUser(state),
  countryCode: state.geoReducers.countryCode,
})

const mapDispatchToProps = dispatch => ({
  changePhoneNumber: (...args) => dispatch(userActions.changePhoneNumber(...args)),
  getCountry: () => dispatch(geoActions.getCountry()),
})

export default connect(mapStateToProps, mapDispatchToProps)(SubmitPhone)
